module.exports = __webpack_public_path__ + "img/ic_nav_magazin.1937bfc8.svg";